import { List, Map } from "lucide-react";
import Link from "next/link";
import type { ReactNode } from "react";

import { type ViewMode } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/constants";
import { cn } from "@/lib/utils";

interface ViewModeToggleProps {
  viewMode: ViewMode;
  getModeUrl: (mode: ViewMode) => string;
  listTestId?: string;
  mapTestId?: string;
}

function getClassName(active: boolean) {
  return cn(
    "inline-flex items-center justify-center rounded-md font-medium min-w-9 px-2 h-7 text-xs transition-colors",
    active
      ? "bg-foreground text-primary-foreground"
      : "hover:bg-muted hover:text-muted-foreground",
  );
}

export function ViewModeToggle({
  viewMode,
  getModeUrl,
  listTestId,
  mapTestId,
}: ViewModeToggleProps): ReactNode {
  return (
    <div className="flex gap-0.5 border rounded-lg p-0.5 bg-surface-subtle">
      <Link
        href={getModeUrl("list")}
        data-testid={listTestId}
        className={getClassName(viewMode === "list")}
        aria-label="List view"
        aria-pressed={viewMode === "list"}
      >
        <List className="h-3.5 w-3.5" />
      </Link>
      <Link
        href={getModeUrl("map")}
        data-testid={mapTestId}
        className={getClassName(viewMode === "map")}
        aria-label="Map view"
        aria-pressed={viewMode === "map"}
      >
        <Map className="h-3.5 w-3.5" />
      </Link>
    </div>
  );
}
